import { useSyncExternalStore } from 'react';

/**
 * A goal plan being made while its modal is closed ("Continue in the background"): the modal writes the
 * latest progress here, the home screen shows it above the AI quota. null when nothing runs in the background.
 */
export interface BackgroundPlan {
  /** 0-100, the same visual value the modal's bar uses */
  progress: number;
  statusMessage: string;
  goalTitle?: string | null;
}

let current: BackgroundPlan | null = null;
const listeners = new Set<() => void>();

export const setBackgroundPlan = (next: BackgroundPlan | null): void => {
  current = next;
  listeners.forEach((listener) => listener());
};

export const getBackgroundPlan = (): BackgroundPlan | null => current;

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const useBackgroundPlan = (): BackgroundPlan | null => useSyncExternalStore(subscribe, getBackgroundPlan);
